<template>
    <div id="content">
      <div id="pageContent">
        <div class="pageHeader">
          <div class="white flex flex-column hcenter" style="font-family: TruenoBd;padding-left: 10%;height: 100%">
            <div class="pageTitle">产业布局</div>
            <div class="subPageTitle">/INDUSTRIAL LAYOUT</div>
          </div>
        </div>
        <div class="tabs flex justify-spaceBetween vcenter ">
         
          <div class="flex1 t-right " >
            <span>您的位置：</span>
            <a href="/">首页 </a>
            <span>&gt; 产品与服务</span>
          </div>
        </div>
        <div class="advantage mt4" style="margin-bottom:76px">
          <div class="white flex vcenter industrial1" style="font-family: TruenoBd;height: 100%;align-items: flex-start">
            <div class="ml8 content mb6 ">
              <div class="pageTitle" style="color:#111D2B;font-size:32px !important">营养与健康</div>
              <div class="subPageContent mt4 contentText">
                <p class="contentTextIndet">〇 我们探寻从婴儿至老年人的全生命周期营养素研究 </p>
                <div class="goDetail outline hoverGreen mt4 ml3" style="border: 1px solid rgba(17, 29, 43, 0.34);width:300px" @click="$router.push({path:'/hmo'})">
                    了解 母乳低聚糖（HMO） <span>➝</span>
                </div>               
              </div>
            </div>
            <div class="scale"><img class="advantage1" src="../assets/industrial/industrial1.png"></div>
          </div>
        </div>
        <div class="advantage mt4">
          <div class="white flex vcenter pl8 industrial2" style="font-family: TruenoBd;height: 100%;align-items: flex-start">
            <div class="scale mb6"><img class=" advantage1 " src="../assets/industrial/industrial2.png"></div> 
            <div class="content ml8 ">
              <div class="pageTitle" style="color:#111D2B;font-size:32px !important">食品与安全</div>
              <div class="subPageContent mt4 contentText">
                <p class="contentTextIndet">〇 我们寻求生态循环的未来新型食品，打破能源的掣肘 </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'About',
  methods: {
    // go(name) {
    //   var scrollTop = document.getElementById(name).scrollTop;
    // }
  }
}
</script>

<style lang="scss" scoped>
    .pageHeader{
        overflow: hidden; width: 100%; height: 494px;
        background-image: url("../assets/industrial/banner.png");
        background-position: 95% 50%;
        background-size: cover;
    }
    .title {
      display: block;
      font-size: 43px;
      font-weight: 600;
      color: #111D2B;
      line-height: 1;
    }
    .info {
      color: #111D2B;
      opacity: 0.5;
      font-weight: 400;
      font-size: 16px;
      text-align: center;
      line-height: 1.8;
      max-width: 800px;
      margin: 0 auto;
      margin-top: 21px;
    }
   .advantage{
      width: 100%;
      padding:0;
      div{
        justify-content: center;
        .content{
          width: 590px;
        }

        flex-wrap: wrap;
        .pageTitle{
          font-size: 43px;
          font-weight: 600;
          color: #111D2B;
        }
        .subPageContent{
          font-size: 21px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          width: 60%;
        }
        
      }
    }
    .advantage2{
      width: 80%;
    }
    @media screen and (max-width: 1412px) {
      .industrial2{
        flex-wrap: wrap-reverse !important;
        padding-left: 0 !important;
      }
      .industrial1{
        padding-left: 0 !important;
      }
     

    }
    @media screen and (max-width: 1286px) {
      .advantage1{
        width: 100%;
      }
      .advantage2{
      width: 100%;
    }
    .advantage>div{
      width: 90% !important;
      margin:0 auto;
      align-items: left;
      .content{
        margin-left: 0 !important;
      }
    }
      .subPageContent{
        width: 90% !important;
      }
    }
    @media screen and (max-width: 975px) {
      .advantage{
        padding: 0 10px !important;
      }
      // .pageHeader{
      //   background-position: 73% 50%;
      // }
    }
    @media screen and (max-width: 768px) {
      .goDetail{
        width: 250px !important;
        font-size: 16px !important;
      }
    }
    
</style>



// WEBPACK FOOTER //
// src/views/product.vue